// 设计稿配置
const designs = {
  pc: { width: 1920, baseFont: 100 },
  mobile: { width: 750, baseFont: 75 },
};
export function setRemUnit(design = "pc") {
  // const { width, baseFont } = designs[design];
  // 根字体计算逻辑
  const designWidth = 1920;
  const clientWidth = document.documentElement.clientWidth;
  const rem = clientWidth * (100 / designWidth);
  document.documentElement.style.fontSize = `${Math.min(rem, 200)}px`;
}

// 初始化调用
// setRemUnit();

// 防抖处理
let timer;
export function handleResize() {
  clearTimeout(timer);
  timer = setTimeout(setRemUnit, 300);
}



// WEBPACK FOOTER //
// ./src/utils/flexible.js